import { Component, inject, signal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LanguageSelectorUI } from '@insolution/language-ui';

@Component({
  selector: 'lib-language-selector',
  imports: [LanguageSelectorUI],
  templateUrl: './language-selector.html',
  styleUrl: './language-selector.scss',
})
export class LanguageSelector {
  private translateService = inject(TranslateService);
  protected availableLanguages = this.translateService.getLangs();
  protected currentLanguage = signal(this.translateService.getCurrentLang());

  constructor() {
    this.translateService.onLangChange
      .pipe(takeUntilDestroyed())
      .subscribe((lang) => this.currentLanguage.set(lang.lang));
  }

  protected setCurrentLang(lang: string) {
    this.translateService.use(lang);
  }
}
